import { DASHBOARD_URL_CONFIG_FILE } from '@/enviroment/app'
import loggerService from './logger'
import componentService from './component'
import translationService from './translation'
import connectionService from './connection'
import eventService from './events'
import httpClient from './http'
export { LOG_SUCCESS, LOG_ERROR } from './logger'
export const PATH_URL = DASHBOARD_URL_CONFIG_FILE

export const getUrlParam = (param) => {
  let params = decodeURIComponent(window.location.href).split('?')
  let regExpression = new RegExp(`${param}=([^&$]*)`, 'gi')
  let regExpressionExec = params.length === 2 ? regExpression.exec(params[1]) : undefined
  return regExpressionExec && regExpressionExec.length === 2 ? regExpressionExec[1] : undefined
}

export default {
  component: componentService,
  logger: loggerService,
  translation: translationService,
  connection: connectionService,
  http: httpClient,
  event: eventService
}
